import { render, staticRenderFns } from "./View8.vue?vue&type=template&id=58b7fee2&scoped=true&"
import script from "./View8.vue?vue&type=script&lang=js&"
export * from "./View8.vue?vue&type=script&lang=js&"
import style0 from "./View8.vue?vue&type=style&index=0&id=58b7fee2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b7fee2",
  null
  
)

export default component.exports